var _rect, _circle, _path, _path2, _path3, _path4, _rect2, _path5, _path6, _path7, _rect3, _path8, _path9, _path10, _rect4, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect5, _rect6, _rect7, _rect8, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    fill: "transparent"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 45,
    fill: "#061042"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 5 L53 15 L60 7 L58 18 L68 12 L63 22 L75 18 L67 28 L82 26 L72 34             L88 35 L76 40 L90 45 L77 48 L88 55 L74 54 L82 65 L70 60 L74 70 L64 62             L65 76 L55 65 L50 80 L45 65 L35 76 L36 62 L26 70 L30 60 L18 65 L26 54             L12 55 L23 48 L10 45 L24 40 L12 35 L28 34 L18 26 L33 28 L25 18 L37 22             L32 12 L42 18 L40 7 L47 15 Z",
    fill: "#0A1855"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 8 L49 12 L48 45 L50 50 L52 45 L51 12 Z",
    fill: "#1F2A60",
    stroke: "#112060",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 8 L50 45",
    fill: "none",
    stroke: "#5B9BD5",
    strokeWidth: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48 L54 48",
    fill: "#3D4C88"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 48,
    width: 4,
    height: 5,
    fill: "#3D4C88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12 L38 14 L41 45 L43 48 L45 45 L42 14 Z",
    fill: "#1F2A60",
    stroke: "#112060",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12 L41 45",
    fill: "none",
    stroke: "#5B9BD5",
    strokeWidth: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39 48 L47 48",
    fill: "#3D4C88"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 48,
    width: 4,
    height: 4,
    fill: "#3D4C88"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60 12 L58 14 L56 45 L58 48 L60 45 L62 14 Z",
    fill: "#1F2A60",
    stroke: "#112060",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60 12 L58 45",
    fill: "none",
    stroke: "#5B9BD5",
    strokeWidth: 0.7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48 L62 48",
    fill: "#3D4C88"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 48,
    width: 4,
    height: 4,
    fill: "#3D4C88"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18 L28 20 L36 45 L38 48 L40 45 L32 21 Z",
    fill: "#112060",
    stroke: "#0A1855",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18 L36 45",
    fill: "none",
    stroke: "#5B9BD5",
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47 L42 47",
    fill: "#3D4C88"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70 18 L72 20 L64 45 L62 48 L60 45 L68 21 Z",
    fill: "#112060",
    stroke: "#0A1855",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70 18 L64 45",
    fill: "none",
    stroke: "#5B9BD5",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47 L58 47",
    fill: "#3D4C88"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30 L18 32 L32 43 L35 45 L36 42 L22 31 Z",
    fill: "#112060",
    stroke: "#0A1855",
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30 L32 43",
    fill: "none",
    stroke: "#5B9BD5",
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31 45 L37 43",
    fill: "#3D4C88"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30 L82 32 L68 43 L65 45 L64 42 L78 31 Z",
    fill: "#112060",
    stroke: "#0A1855",
    strokeWidth: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30 L68 43",
    fill: "none",
    stroke: "#5B9BD5",
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69 45 L63 43",
    fill: "#3D4C88"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15 40 L32 50 M15 60 L34 50 M25 70 L38 50 M40 78 L43 50            M85 40 L68 50 M85 60 L66 50 M75 70 L62 50 M60 78 L57 50",
    fill: "none",
    stroke: "#112060",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15 40 L32 50 M15 60 L34 50 M25 70 L38 50 M40 78 L43 50            M85 40 L68 50 M85 60 L66 50 M75 70 L62 50 M60 78 L57 50",
    fill: "none",
    stroke: "#5B9BD5",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 60,
    width: 30,
    height: 15,
    rx: 2,
    ry: 2,
    fill: "#3D4C88"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 63,
    width: 24,
    height: 1.5,
    fill: "#5B6AA6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 67,
    width: 24,
    height: 1.5,
    fill: "#5B6AA6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 71,
    width: 24,
    height: 1.5,
    fill: "#5B6AA6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 50,
    r: 2,
    fill: "#3D4C88",
    stroke: "#5B9BD5",
    strokeWidth: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 50,
    r: 2,
    fill: "#3D4C88",
    stroke: "#5B9BD5",
    strokeWidth: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 50,
    r: 2,
    fill: "#3D4C88",
    stroke: "#5B9BD5",
    strokeWidth: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 50,
    r: 2,
    fill: "#3D4C88",
    stroke: "#5B9BD5",
    strokeWidth: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 50,
    r: 2,
    fill: "#3D4C88",
    stroke: "#5B9BD5",
    strokeWidth: 0.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 50,
    r: 2,
    fill: "#3D4C88",
    stroke: "#5B9BD5",
    strokeWidth: 0.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 50,
    r: 2,
    fill: "#3D4C88",
    stroke: "#5B9BD5",
    strokeWidth: 0.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 50,
    r: 2,
    fill: "#3D4C88",
    stroke: "#5B9BD5",
    strokeWidth: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 80,
    width: 70,
    height: 5,
    rx: 1,
    ry: 1,
    fill: "#1D2862"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGot);
export default __webpack_public_path__ + "static/media/got.e51d42dccf01524067e3a1a59b8a5cda.svg";
export { ForwardRef as ReactComponent };